module.exports = __webpack_public_path__ + "img/icon-telegram-dark.6ec8ec13.svg";